import styled from "styled-components";

export const PreviewImage = styled.img`
  width: 100%;
  height: auto;
`;
